import { TreeNode, walkTreeNodes } from '../../lib/tree-node';

export default class TreeViewController {
  static $inject = ['$timeout'];

  private nodes: TreeNode[];
  private initialSelection?: string;
  private onSelect: ($args: { $key: string }) => void;

  constructor(private $timeout) {}

  $onInit() {
    if (this.initialSelection) {
      this.handleSelection(this.initialSelection);
    }
  }

  handleSelection($key: string) {
    this.$timeout(() => {
      walkTreeNodes(this.nodes, (node) => {
        if (node) {
          node.selected = node.key == $key;
        }
      });
    });

    if (this.onSelect) {
      this.onSelect({ $key });
    }
  }
}
